import logger from "../common/Logger"
import CoreService from './CoreService'
import ApiService from './ApiService'

class SettingsService {
    static saveSettings(settings) {
        ApiService.makeRequest("/api/bots/default/settings", {
            type: "POST",
            data: JSON.stringify(settings),
            success: function () {
                CoreService.navigateToHome();
            },
            error: function (result, err) {
                if (err) logger.error(err);
                CoreService.showPassiveError("Sorry, we can't save your settings right now.");
            }
        });
    }

    static loadSettings(callback) {
        ApiService.makeRequest("/api/bots/default/settings", {
            type: "GET",
            success: callback,
            error: function (result, err) {
                if (err) logger.error(err);
                CoreService.showPassiveError("Sorry, we can't fetch your connection settings right now.");
            }
        });
    }
}

export default SettingsService;



// WEBPACK FOOTER //
// ./src/modules/service/SettingsService.js